export default __webpack_public_path__ + "26e47223a1a307b9f8cdaa923120a8ab.png";